import moment from 'moment';

export function toIsoString(value?: string): string | undefined {
    if (!value) return undefined;
    const m = moment(value);
    if (!m.isValid()) return undefined;
    return m.toISOString();
}

export function buildShiftsQuery(where: string): string {
    return `query($from: DateTime!, $to: DateTime!) {
        shifts(pageSize: 999999, where: ${where}) {
            id
            fromDate
            toDate
            okCount
            nokCount
            planCount
            workplaceId
            workplace { id code name location { id parentalLocationId } }
            shiftTypeId
            shiftType { id name }
            shiftTeamTypeId
            shiftTeamType { id name }
            shiftProductions { 
                projectId 
                project { id name }
                productId
                product { id name code productCollectionId }
                okCount nokCount 
            }
        }
    }`;
}

export function buildPlanItemsQuery(where: string): string {
    return `query($from: DateTime!, $to: DateTime!) {
        planItems(pageSize: 999999, where: ${where}) {
            id
            workplaceId
            workplace { id code name location { id name } }
            stationId
            station { id name }
            shutdownFromDate
            shutdownToDate
            shutdownDuration
            reactionDuration
            hourlyMaintenanceCosts
            hourlyDowntimeCosts
            hourlyDowntimeLostProfit
            auditFaultTypeId
            auditFaultType { id name priority color }
            defectId
            defect { id code name }
            machineComponentId
            machineComponent { id code name }
            shiftId
            shiftTypeId
            shift { id shiftTypeId shiftTeamTypeId shiftProductions { id projectId } }
        }
    }`;
}

export function buildPlanItemsWithResponsesQuery(where: string): string {
    return `query($from: DateTime!, $to: DateTime!) {
        planItems(pageSize: 999999, where: ${where}) {
            id
            workplaceId
            workplace { id code name location { id name } }
            stationId
            station { id name }
            shutdownFromDate
            shutdownToDate
            shutdownDuration
            reactionDuration
            hourlyMaintenanceCosts
            hourlyDowntimeCosts
            hourlyDowntimeLostProfit
            auditFaultTypeId
            auditFaultType { id name priority color }
            defectId
            defect { id code name }
            machineComponentId
            machineComponent { id code name }
            shiftId
            shiftTypeId
            shift { id shiftTypeId shiftTeamTypeId shiftProductions { id projectId } }
            responses {
                id
                problemDescription
                immediateMeasures
            }
        }
    }`;
}

export function buildPanelDashboardPlanItemsQuery(where: string): string {
    return `query($referenceDateTime: DateTime!) {
        planItems(pageSize: 999999, where: ${where}) {
            id
            workplaceId
            workplace { id code name locationId }
            time
            processType
            planItemState
            isWorkplaceShutdown
            shutdownFromDate
            shutdownToDate
            station { id name }
            auditFaultType { id name priority color }
            reportedBy { id user { id firstName lastName } }
            tenantUser { id user { id firstName lastName } }
        }
    }`;
}

export function buildShiftScrapRecordsQuery(where: string): string {
    return `query($from: DateTime!, $to: DateTime!) {
        shiftScrapRecords(pageSize: 999999, where: ${where}) {
            id
            shiftId
            recordTime
            scrapCount
            scrapCostsPerUnit
            stationId
            station { id name workplace { id code name } }
            product { id name scrapCosts }
            scrapReasonId
            scrapReason { id name }
            shift { 
                id 
                shiftTypeId 
                shiftType { id name }
                shiftTeamTypeId 
                shiftTeamType { id name code }
                shiftProductions { id projectId project { id name } } 
            }
        }
    }`;
}

export function buildCycleTimesQuery(): string {
    return `query {
        cycleTimes(pageSize: 999999) {
            id
            cycleTimeType
            workplaceId
            workplace { id code name }
            locationId
            location { id code name }
            productId
            product { id code name }
            productCollectionId
            productCollection { id name }
            timePerUnit
        }
    }`;
}



